//Need to separate between this and Summit Models SummitConfig
import { DayOfWeek } from '@summit/models';

export const Config = {
  version: '2026.02.28.2254',
  dataValidityWarning: 10 * 60 * 1000, // Show Tooltip that the data is old after X milliseconds
  dataValidityCheck: 60 * 1000,
  // Testing values
  // dataValidityWarning: 10 * 1000, // Show Tooltip that the data is old after X milliseconds
  // dataValidityCheck: 10 * 1000,

  // TimeSpan when Expiration Dates are flagged
  expirationDateAlarm: 30 * 24 * 60 * 60 * 1000,
  expirationDateWarning: 60 * 24 * 60 * 60 * 1000,
  expirationDateFlag: 90 * 24 * 60 * 60 * 1000,
  defaultViewName: 'Normal',
  payrollLocksAfter: 14, // Days
  timelineEditStopsAfter: 14, // Days
  defaultEndOfWeek: DayOfWeek.Friday,
  defaultEndOfScheduleWeek: DayOfWeek.Sunday,
  defaultEndOfIvmrWeek: DayOfWeek.Saturday
};

